import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { resolveScheme } from "../../../../utils/ipfs.js";
import { ChainActiveDot } from "./ChainActiveDot.js";
import { Img } from "./Img.js";
import { Container } from "./basic.js";
import { fallbackChainIcon } from "./fallbackChainIcon.js";
/**
 * This component (file) will eventually be replaced with the ChainIcon prebuilt version.
 * @internal
 */
export const ChainIcon = (props) => {
    return (_jsxs(Container, { style: {
            position: "relative",
            display: "flex",
            flexShrink: 0,
            alignItems: "center",
        }, children: [_jsx(Img, { src: getSrcChainIcon(props), width: props.size, height: props.size, fallbackImage: fallbackChainIcon, client: props.client }), props.active && (_jsx(ChainActiveDot, { className: "tw-chain-active-dot-legacy-chain-icon" }))] }));
};
/**
 * @internal
 */
export const getSrcChainIcon = (props) => {
    const url = props.chainIconUrl;
    if (!url) {
        return fallbackChainIcon;
    }
    try {
        return resolveScheme({
            uri: url,
            client: props.client,
        });
    }
    catch {
        return fallbackChainIcon;
    }
};
//# sourceMappingURL=ChainIcon.js.map